/* INSCAPE Landing Page – Vorbestellung und Ausverkauft: Hinweis, Button-Text, Liefertermin und Benachrichtigen-Button je gewähltem Angebot */
(function () {
  'use strict';
  if (window.__lpPreorder) return;
  window.__lpPreorder = true;
  function apply(hero) {
    var sel = hero.querySelector('.lp-offer__radio:checked');
    if (!sel) return;
    var pre = sel.getAttribute('data-preorder') === 'true';
    var avail = sel.getAttribute('data-available') === 'true';
    hero.classList.toggle('is-soldout', !avail);
    hero.querySelectorAll('[data-lp-preorder]').forEach(function (el) { el.hidden = !pre; });
    hero.querySelectorAll('[data-lp-delivery]').forEach(function (el) {
      var txt = el.querySelector('[data-lp-delivery-text]');
      if (pre || !avail) { el.hidden = true; } else if (txt && txt.innerHTML) { el.hidden = false; }
    });
    hero.querySelectorAll('[data-lp-atc]').forEach(function (b) {
      var lbl = b.querySelector('[data-lp-atc-label]');
      var preLabel = b.getAttribute('data-preorder-label');
      if (lbl && avail && preLabel) lbl.textContent = pre ? preLabel : b.getAttribute('data-label');
    });
  }
  function init() {
    document.querySelectorAll('[data-lp-hero]').forEach(function (hero) {
      if (hero.__lpPre) return;
      hero.__lpPre = true;
      hero.addEventListener('change', function (e) {
        if (e.target && e.target.classList && e.target.classList.contains('lp-offer__radio')) setTimeout(function () { apply(hero); }, 0);
      });
      setTimeout(function () { apply(hero); }, 0);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', function () {
    document.querySelectorAll('[data-lp-hero]').forEach(function (h) { apply(h); });
  });
  document.addEventListener('shopify:section:load', init);
})();
